import { render, staticRenderFns } from "./RelatedLegisChecklist.vue?vue&type=template&id=19872dd6&scoped=true&"
import script from "./RelatedLegisChecklist.vue?vue&type=script&lang=js&"
export * from "./RelatedLegisChecklist.vue?vue&type=script&lang=js&"
import style0 from "./RelatedLegisChecklist.vue?vue&type=style&index=0&id=19872dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19872dd6",
  null
  
)

export default component.exports